/**
 * Google Analytics 4 — gtag.js is loaded in public/index.html.
 * Keep MEASUREMENT_ID in sync with the id in index.html.
 * Optional: set REACT_APP_GA_MEASUREMENT_ID in .env to override (e.g. staging).
 */

const MEASUREMENT_ID =
  process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-K3SW4V6SWP';

export function isAnalyticsEnabled() {
  return Boolean(MEASUREMENT_ID);
}

/**
 * Send a page view on client-side route changes (React Router).
 * Initial page view is sent by gtag in index.html.
 */
export function trackPageView(path) {
  if (!MEASUREMENT_ID || typeof window === 'undefined' || !window.gtag) return;
  window.gtag('config', MEASUREMENT_ID, {
    page_path: path,
  });
}

/**
 * Optional: custom events (e.g. button clicks, form submits).
 * Example: trackEvent('cta_click', { button_label: 'Schedule call' });
 */
export function trackEvent(eventName, params = {}) {
  if (!MEASUREMENT_ID || typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', eventName, params);
}
